import Injures from "./Injures";
export default class User extends createjs.Container {
	public height         :number;
	public width          :number;
	public id_key         :number;
	public name           :string;

	public levelIndex     :number;
	public levelId        :string;
	public itemNumber     :number;
	public consolefatherId       :number;
	public fatherId       :number;
	public motherId       :number;
	public childrensIds   :Array<number>;
	public couplesIds     :Array<number>;
	public allBrothers    :Array<number>;
	public fullName       :string;

	public bg             :createjs.Shape;
    public border         :createjs.Shape;
    public bg_graphics    :createjs.Graphics;
    public border_graphics:createjs.Graphics;
    public ProfileImage   :Injures;
    public text           :createjs.Text;
	public isCoupleWithoutChildren:boolean;
	public isCouple		  :boolean;
	public otherFamily	  :boolean;

    constructor(id:number, isCoupleWithoutChildren:boolean, img: HTMLImageElement, name:string, brithName:string, birthDate:string, levelId:string, itemNumber:number, cb:Function) {
        super();
        this.id_key                  = null;
		this.isCoupleWithoutChildren = isCoupleWithoutChildren;
 	    this.cursor                  = "pointer";
		// this.alpha                   = 0.5;

		this.width  			 = 200
		this.height 			 = 200;
		this.bg_graphics     	 = new createjs.Graphics().beginFill("#fff").drawRect(1, 1, this.width, this.height);
		// this.border_graphics 	 = new createjs.Graphics().beginFill("#000").drawRect(0, 0, this.width+2, this.height+2);
		// this.border          	 = new createjs.Shape(this.border_graphics);
		this.bg          	 	 = new createjs.Shape(this.bg_graphics);
        this.shadow              = new createjs.Shadow("#d6d6d6", 0, 3, 10);

		this.ProfileImage        = new Injures(img);
		this.ProfileImage.x      = 50;
		this.ProfileImage.y      = 60;
		this.ProfileImage.width  = 100;
		this.ProfileImage.height = 100;

        //create the mask layer
        var mask = new createjs.Shape();
        mask.graphics.drawCircle(100, 100, 50);
        this.ProfileImage.mask = mask;

		this.isCouple 			 = false;
		this.levelId 	         = levelId;
		this.itemNumber 	     = itemNumber;
		this.addChild(this.border);
		this.addChild(this.bg);
		this.addChild(this.ProfileImage);
        if (  brithName !== '' ) {
            name = brithName;
        }
		// this.fullName 			= name + " (" + id+", "+ levelId+", "+ itemNumber+")";
		this.fullName 			= name;
		this.addName(this.fullName);
		this.addName(birthDate, 170);


		this.bg.on("dblclick", (evt) => {
			console.log("dblclick", this.fullName, this.x, this.y);
			cb(this);
		});
		this.ProfileImage.on("dblclick", (evt) => {
			console.log("dblclick", this.fullName, this.x, this.y);
			cb(this);
		});

		//this.addBirtName(brithName);
		//this.addBirthDate(birthDate);
		// console.log('Added', name, brithName, birthDate);

    }

    public addName(title:string, y:number = 30):void{
		this.text            = new createjs.Text(title.substr(0, 200), "14px Barlow", "#5F4F46");
		this.text.lineWidth  = 200;
		this.text.x          = 100;
		this.text.y          = y;
		this.text.textAlign  = 'center';
		this.addChild(this.text);
		var h = ( this.text.getMeasuredHeight() ) * this.text.scaleY;
		this.text.regY = h / 2;
    }

	public addNextBtn(to:string, cb:Function):void{
		var shape = new createjs.Shape(new createjs.Graphics().beginFill("#ccc").drawCircle(1, 1, 10));
		shape.x        = this.width/2;
		if ( to === "top" ) {
			shape.name = 'topBtn';
			shape.y    = - 5 - 10;
		}else{
			shape.name = 'bottomBtn';
			shape.y    = this.height + 5;
		}
		shape.on("mousedown", (evt) => {
			this.removeChild(shape);
			cb();
		});
		this.addChild(shape);
	}

	public removeAllBtns():void{
		this.removeByName('topBtn');
		this.removeByName('bottomBtn');
	}

	public removeByName(name:string):void{
 	   var child = this.getChildByName(name);
 	   if ( child !== null ) {
 		   this.removeChild(child);
 	   }
    }

	public getAllConnectedUsers():Array<number>{
		var allConnectedUsers:Array<number> = [];
		if ( this.childrensIds !== null ) {
			allConnectedUsers = allConnectedUsers.concat(this.childrensIds);
		}
		if ( this.couplesIds !== null ) {
			allConnectedUsers = allConnectedUsers.concat(this.couplesIds);
		}
		if ( this.allBrothers !== null ) {
			allConnectedUsers = allConnectedUsers.concat(this.allBrothers);
		}
		if ( this.fatherId !== null ) {
			allConnectedUsers.push(this.fatherId);
		}
		if ( this.motherId !== null ) {
			allConnectedUsers.push(this.motherId);
		}
		return allConnectedUsers;
	}

	//
	// public addBirtName(str:string){
	// 	var text = new createjs.Text('Szül. név: '+ str, "italic 15px Scada", "#c1895a");
	// 	text.x = this.text.x;
	// 	text.y = 35;
	// 	this.addChild(text);
	// }
	//
	// public addBirthDate(str:string){
	// 	var text = new createjs.Text('Szül. idő: '+ str, "15px Scada", "#5f4f46");
	// 	text.x = this.text.x;
	// 	text.y = 60;
	// 	this.addChild(text);
	// }
}



// WEBPACK FOOTER //
// ./components/family_tree/items/User.ts